<script setup>
import {defineProps, defineEmits} from 'vue'

defineProps({
    show: Boolean,
    loading: Boolean,
    disabled: Boolean,
    error: Boolean,
});

const emit = defineEmits(['press']);

function press() {
    emit('press');
}
</script>

<template>
    <w-btn
        v-if="show"
        :color="error ? 'red' : 'teal'"
        :loading="loading"
        :disabled="disabled"
        :text="$t('common.add')"
        :icon="error ? 'mdi-alert' : 'mdi-plus-circle-outline'"
        @press="press"
    />
</template>

<style scoped>

</style>